/**
 * Locale-aware number formatting helpers.
 *
 * One source of truth for how nutrition numbers render across the app.
 * Calories are integers, gram values get one decimal. Wraps Intl.NumberFormat
 * so the decimal separator follows the user's language (e.g. de uses `,`).
 */

function safeNumber(value) {
  if (value == null) return 0
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) ? n : 0
}

export function formatCalories(value, locale = 'en') {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(
    Math.round(safeNumber(value))
  )
}

export function formatGrams(value, locale = 'en') {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(safeNumber(value))
}

export function formatNumber(value, locale = 'en', opts = {}) {
  return new Intl.NumberFormat(locale, opts).format(safeNumber(value))
}
